import React from 'react';
import './SeriesView.scss';
import FileListEntry from '../Page/Sections/MediaLibrary/FileListEntry';

class SeriesView extends React.Component {
  constructor() {
    super(...arguments);

    this.props.series.ensureLoaded().then(() => {
      this.forceUpdate();
    });
    let siteProps = FW.store.get('site').get('properties');
    this.socialProps = siteProps
      ? siteProps.social_media_settings
        ? siteProps.social_media_settings
        : {}
      : {};
  }

  componentDidMount() {
    this.props.series.on(
      'change',
      () => {
        this.forceUpdate();
      },
      this
    );
    let templateID = FW.store.get('template')
      ? FW.store.get('template').get('id')
      : -1;
    if (templateID === 3) {
      $('#mainNav').removeClass('affix-top');
    }
  }

  componentWillUnmount() {
    this.props.file.off(null, null, this);
  }

  goBack(e) {
    e.preventDefault();
    window.history.back();
  }

  render() {
    const series = this.props.series;
    let file = series.get('cover');
    this.socialProps.picture = file ? file.get('id') : null;
    this.socialProps.tags = this.socialProps.tags || '';
    this.socialProps.title = series.get('title') || this.socialProps.title;
    this.socialProps.description =
      series.get('description') || this.socialProps.description;

    const fileCollection = series.get('files');
    if (FW.store.get('site').prop('ml_series_oldest_first')) {
      fileCollection.sortByField('display_date', 'ASC');
      fileCollection.sort();
    }

    const files = fileCollection.map((file, i) => {
      return <FileListEntry showThumbnail={true} file={file} key={i} />;
    });

    return (
      <div id="mediaSeriesContainer" className={'clearfix'} style={{}}>
        <div
          id={'coverImage'}
          style={
            file && file.helper
              ? {backgroundImage: `url(${file.helper.featuredUrl()})`}
              : {}
          }
        >
          <div id={'overlay'} />
          <div id={'titleText'}>
            <h1 id={'title'}>{series.get('title')}</h1>
          </div>
        </div>
        <a href="#" onClick={this.goBack} style={{textAlign: 'left', paddingLeft: 20, display: 'block'}}>
          <h3>
            <i className="fa fa-arrow-left" aria-hidden="true" /> Back
          </h3>
        </a>
        <p id={'description'}>{series.get('description')}</p>
        <div id={'filesContainer'}>{files}</div>
      </div>
    );
  }
}

export default SeriesView;
